// extracted by css-extract-rspack-plugin
export default {"cls1":"FeedbackForm-cls1_LXI","cls2":"FeedbackForm-cls2_zpA FeedbackForm-cls1_LXI"};